import throttle from '../../helpers/throttle'

const onScroll = ((window, $) => {
	const init = () => {
		const setCSSVar = (siteHeader) => {
			const root = document.documentElement
			const siteHeaderHeight = siteHeader.outerHeight(true)
			root.style.setProperty(
				'--site-inner-margin-top',
				`${siteHeaderHeight + 20}px`
			)
		}
		const $window = $(window),
			siteHeader = $('.site-header')

		setCSSVar(siteHeader)

		const updateThrottleResize = throttle(() => {
			$window.on('scroll', function () {
				const bodyScroll = $window.scrollTop()
				setCSSVar(siteHeader)
				if (bodyScroll > 145) {
					siteHeader.addClass('site-header-with-scroll')
				} else {
					siteHeader.removeClass('site-header-with-scroll')
				}
			})

			$window.on('resize', function () {
				setCSSVar(siteHeader)
			})
		}, 500)

		updateThrottleResize()
	}

	return {
		init,
	}
})(window, jQuery)

export default onScroll
